import { __read } from "tslib";
import { useState } from 'react';
import { focusWithoutScrolling, setCursorToEnd } from '../../libs/dom-utils';
export function usePasswordField(props, inputRef) {
    var disabled = props.disabled;
    var _a = __read(useState(false), 2), isShown = _a[0], setShown = _a[1];
    var onPress = function () {
        setShown(!isShown);
        if (inputRef.current) {
            focusWithoutScrolling(inputRef.current);
        }
        // Use raf for set cursor at the end after layout changed.
        requestAnimationFrame(function () {
            setCursorToEnd(inputRef.current);
        });
    };
    return {
        isShown: isShown,
        buttonProps: {
            disabled: disabled,
            onPress: onPress,
            preventFocusOnPress: true,
            tabIndex: -1,
        },
        inputProps: {
            type: isShown ? 'text' : 'password',
        },
    };
}
